import axios from 'axios';

export const fetchStockAvailabilityReports = projectId => axios.get(`/projects/${projectId}/reports?type=stock_availability`);

export default {
  fetchStockAvailabilityReports
};
